import { StyledButton, StyledContent, StyledTitle } from '@/components/styles'
import { ContentSection, FeedBack, Review } from '@/components'
import { useLoadMore } from '@/hooks'
import api from '@/lib/api'
import { useTranslation } from "react-i18next";

export default function ReviewsPage(props) {
  const { paginator } = props
  const { t } = useTranslation("global");

  const reviewsPaginator = useLoadMore(api.reviews, paginator)

  return (
    <StyledContent>
      <StyledContent.Container>
        <StyledContent.Columns>
          <div>
            <StyledContent.Side>
              <StyledTitle mb="medium" as="h1">
              {t('reviews.title')}
              </StyledTitle>
              <FeedBack />
            </StyledContent.Side>
          </div>
          <StyledContent.ColumnMain>
            <StyledContent.Loadable isLoading={reviewsPaginator.loading}>
              {reviewsPaginator.items && reviewsPaginator.items.length > 0 ? (
                <ContentSection noTitle>
                  {reviewsPaginator.items.map(review => {
                    const { id, ...otherProps } = review
                    return <Review key={id} {...otherProps} />
                  })}
                </ContentSection>
              ) : (
                <StyledContent.Empty>{t('reviews.empty')}</StyledContent.Empty>
              )}

              {reviewsPaginator.hasMore && (
                <StyledContent.LoadBtn>
                  <StyledButton light onClick={reviewsPaginator.handleLoadMore}>
                  {t('showMore')}
                  </StyledButton>
                </StyledContent.LoadBtn>
              )}
            </StyledContent.Loadable>
          </StyledContent.ColumnMain>
        </StyledContent.Columns>
      </StyledContent.Container>
    </StyledContent>
  )
}
